/**
 * notify.js
 *
 * Thin helper on top of `toggleToast` that provides a single common surface for
 * every application-level notification (errors, success, warning, info). All new
 * code should use `notify.<variant>(message, opts?)` instead of talking to
 * `toggleToast` directly for global (non-modal-scoped) notifications.
 */
import {toggleToast} from './Toast';
import {toastAreas} from '@util/uiconstants';

const base =
	(variant) =>
	(message, opts = {}) =>
		toggleToast({
			area: toastAreas.global,
			variant,
			position: 'top',
			// Errors are sticky by default (match legacy NotificationSystem behavior);
			// status messages auto-dismiss like the existing Motif toast usages.
			duration: variant === 'error' ? 0 : 3000,
			...opts,
			children: message
		});

export const notify = {
	error: base('error'),
	success: base('success'),
	warning: base('warning'),
	info: base('info')
};

export default notify;
